import { Checkbox, Col, Typography, Button } from "antd";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import { ISauce } from "../../../../redux/@types";
import { useProducts } from "../../../products";
import { useParams } from "react-router-dom";
import React from "react";
import { useAssignWerehouseSauces, useWerehouseSauces } from "../../hooks/werehouseSauces";
import Table from "../../../../shared/components/ui/Table";
import { saucesService } from "../../../../shared/services";

const { Title } = Typography;

interface Props {
  fetchQuery?: any;
}

export const TableSaucesByIdWerehouse = ({ fetchQuery: _fetchQuery }: Props) => {
  const { warehouse_id } = useParams();
  const { werehouseSauces, werehouseSaucesInfo } = useWerehouseSauces({
    warehouseId: +warehouse_id!,
  });
  const {assignWerehouseSauces, removeWharehouseSauce} = useAssignWerehouseSauces();

  const [selectedSauceIds, setSelectedSauceIds] = React.useState<Set<number>>(new Set());

  React.useEffect(() => {
    const activeIds = new Set(
      werehouseSaucesInfo
        .filter((info) => info.status === "active")
        .map((info) => info.sauce_id)
    );
    setSelectedSauceIds(activeIds);
  }, [werehouseSaucesInfo]);

  const handleSelect = (productId: number, checked: boolean) => {
    setSelectedSauceIds((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (checked) {
        newSelected.add(productId);
      } else {
        newSelected.delete(productId);
      }
      return newSelected;
    });
  };

  const handleAssignProducts = async () => {
    for (const sauceId of Array.from(selectedSauceIds)) {
      await assignWerehouseSauces({
        sauceId: +sauceId,
        warehouseId: +warehouse_id!,
      });
    }
    await werehouseSauces(); // Refresh the data after assigning
  };

  const handleRemoveProducts = async () => {
    for (const sauceId of Array.from(selectedSauceIds)) {
      await removeWharehouseSauce(+warehouse_id!, sauceId);
    }
    await werehouseSauces(); // Refresh the data after removal
  };

  const { setTableProps } = useProducts();

  const columns: TableColumns<ISauce> = [
    {
      title: "ID",
      width: 2,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      width: 4,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Estado",
      width: 7,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
              // disabled={isLoading}
              //   onClick={()=>{
              //     if(item.status === "active"){
              //       updateStatus("inactive", item.id)
              //     }else if( item.status === "inactive"){
              //       updateStatus("active", item.id)
              //     }
              //   }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Asignar a la bodega",
      key: "operation",
      fixed: "right",
      width: 10,
      render: (_, item) => {
        const isProductAssigned = selectedSauceIds.has(item.id);
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Checkbox
              checked={isProductAssigned}
              onChange={(e) => handleSelect(item.id, e.target.checked)}
            />{" "}
          </Col>
        );
      },
    },
  ];
  

  return (
    <>
      <Button
        type="primary"
        onClick={handleAssignProducts}
        disabled={selectedSauceIds.size === 0}
        style={{ marginBottom: 16 }}
      >
        Asignar Salsas
      </Button>
      <Button
        type="default"
        onClick={handleRemoveProducts}
        disabled={selectedSauceIds.size === 0}
        style={{ marginBottom: 16, marginLeft: 8 }}
      >
        Eliminar Salsas
      </Button>
      <Table<ISauce>
        columns={columns}
        scroll={{ y: 300 }}
        fetchQueryProps={{
          $sort: { id: -1 },
        }}
        service={saucesService}
        onLoad={setTableProps}
      />
    </>
  );
};
